export default __webpack_public_path__ + "static/media/THE_MODERN_DAY_QUEEN_compressed.c110179a.pdf";